import type {
  RouteLocationRaw,
  Router,
} from 'vue-router';

import type { UserNameSpace } from '@modules/user/types';
import { ANONYMOUS_MAIN_ROUTE_NAME } from '@modules/anonymous-main/constants';
import { MAIN_ROUTE_NAME } from '@modules/core/services/router/constants';
import { ERouteNamespace } from '@modules/core/services/router/enums';
import waitAppReady from '@modules/core/utils/waitAppReady';
import {
  ADMIN_DASHBOARD_ROUTE_NAME,
  AFFILIATE_DASHBOARD_ROUTE_NAME,
} from '@modules/dashboard/constants';
import { LOGIN_ROUTE_NAME } from '@modules/login/constants';
import { useCurrentNamespace } from '@modules/permissions/composables';

export default function createUserGuard(router: Router): void {
  const { namespace } = useCurrentNamespace();

  router.beforeEach(async (to) => {
    await waitAppReady();
    return redirectFunc(namespace.value, to?.meta?.namespace);
  });
}

function redirectFunc(
  userNamespace: UserNameSpace | undefined,
  routeNamespace: ERouteNamespace | undefined,
): RouteLocationRaw | boolean | Promise<RouteLocationRaw | boolean> {
  if (routeNamespace === ERouteNamespace.ANY) {
    return true;
  }

  if (userNamespace) {
    if (userNamespace === routeNamespace) {
      return true;
    }

    if (userNamespace === ERouteNamespace.AFFILIATE) {
      return { name: AFFILIATE_DASHBOARD_ROUTE_NAME, force: true };
    }

    if (userNamespace === ERouteNamespace.ADMIN) {
      return { name: ADMIN_DASHBOARD_ROUTE_NAME, force: true };
    }

    return { name: MAIN_ROUTE_NAME };
  }
  if (routeNamespace === ERouteNamespace.ANONYMOUS) {
    return true;
  }
  if (routeNamespace === ERouteNamespace.ROOT) {
    return { name: ANONYMOUS_MAIN_ROUTE_NAME, force: true };
  }
  return { name: LOGIN_ROUTE_NAME, force: true };
}
